import React, { useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  currencyFormatter,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";

const TopUpTable = ({
  invoiceData = [],
  setTotalTax,
  setGrandTotal,
  setSubTotal,
  grandTotal,
  subTotal,
  totalTax,
  createInvoice,
}) => {
  // Table columns
  const columns = [
    {
      dataField: "item",
      text: "Tipe",
    },
    {
      dataField: "qty",
      text: "Kouta",
    },
    {
      dataField: "price",
      text: "Harga Satuan",
    },
    {
      dataField: "total_price",
      text: "Total",
      classes: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
      footerClasses: "text-right",
      headerClasses: "text-right",
      footer: (cell) => {
        const sum = cell.reduce((prev, curr) => +prev + +curr, 0);
        const tax = (sum * process.env.REACT_APP_VAT) / 100;
        setTotalTax(tax);
        setGrandTotal(sum + tax);
        setSubTotal(sum);
        return;
      },
    },
  ];
  return (
    <>
      <div className="row">
        <div className="col-lg-1"></div>
        <div className="col-lg-10">
          <BootstrapTable
            wrapperClasses="table-responsive"
            striped
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            bordered={false}
            remote
            keyField="uuid"
            data={invoiceData === null ? [] : invoiceData}
            columns={columns}
          />
        </div>
        <div className="col-lg-1"></div>
      </div>
      <div className="form-group row">
        <div className="col-lg-9 text-right mt-2">
          <h4>Sub Total : </h4>
        </div>
        <div className="col-lg-3">
          <input
            className="form-control text-right font-weight-bold"
            disabled
            value={currencyFormatter(subTotal)}
            label="Nominal"
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-lg-9 text-right mt-2">
          <h4>Pajak ({process.env.REACT_APP_VAT}%): </h4>
        </div>
        <div className="col-lg-3">
          <input
            className="form-control text-right font-weight-bold"
            disabled
            value={currencyFormatter(totalTax)}
            label="Nominal"
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-lg-9 text-right mt-2">
          <h4>Total Pembayaran: </h4>
        </div>
        <div className="col-lg-3">
          <input
            className="form-control text-right font-weight-bold"
            disabled
            value={currencyFormatter(grandTotal)}
            label="Nominal"
          />
        </div>
      </div>
      <div>
        {/* {invoiceData.length > 0 && ( */}
        <>
          <button
            className="btn btn-primary float-right"
            onClick={createInvoice}
            disabled={grandTotal < 100000 && true}
          >
            Buat Invoice
          </button>
          <br />
          <br />
          <p className="text-muted float-right">
            Minimal Pembelian Rp.100.000,00
          </p>
        </>
        {/* )} */}
      </div>
    </>
  );
};

export default TopUpTable;
